import { createContext } from "react";
import { User } from "./user";

export type AppContext = {
    user: User | null;
    setUser: (user: User | null) => void;
}

export const Context = createContext<AppContext>({
    user: null,
    setUser: () => {}
});